import { ReactNode, useRef } from "react";
import { Icon } from "../icon/icon";

export const Checkbox = ({
  checkStatus,
  handleChange = () => {},
  text = "",
  textPosition = "right",
  className = "right",
  disabled = false,
}: {
  checkStatus: boolean;
  disabled?: boolean;
  handleChange: (status: boolean) => void;
  text?: ReactNode;
  textPosition?: "left" | "right";
  className?: string;
}) => {
  const checkBoxRef = useRef<HTMLInputElement | null>(null);

  return (
    <button
      className={`flex w-fit items-center gap-[10px] disabled:cursor-not-allowed ${className} `}
      onClick={() => {
        checkBoxRef?.current?.click();
      }}
      disabled={disabled}
    >
      {textPosition === "left" && (
        <span className="block text-sm font-bold">{text}</span>
      )}

      <Icon
        svg={checkStatus ? "checkbox-active" : "checkbox-inactive"}
        width={16}
        height={16}
      />

      {textPosition === "right" && (
        <span className="block text-sm font-bold">{text}</span>
      )}

      <input
        type="checkbox"
        className="hidden"
        ref={checkBoxRef}
        checked={checkStatus}
        onChange={(e) => {
          handleChange(!checkStatus);
        }}
        disabled={disabled}
      />
    </button>
  );
};
